import { render } from "./fuwenben.vue?vue&type=template&id=f4d2ecde&scoped=true"
import script from "./fuwenben.vue?vue&type=script&lang=js"
export * from "./fuwenben.vue?vue&type=script&lang=js"

import "./fuwenben.vue?vue&type=style&index=0&id=f4d2ecde&scoped=true&lang=css"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d2ecde"]])

export default __exports__